/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { DollarOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import type { TeamHistoryOfficialView } from '@sportninja/common/features/registration/teamHistory'
import Text from 'src/components/ts-components/Text'
import OfficialAvatar from './OfficialAvatar'

interface Props {
  official: TeamHistoryOfficialView
  treasurerLabel: string
}

/** An official in the summary card: avatar, name, role, treasurer pill. */
const SummaryOfficialRow = ({ official, treasurerLabel }: Props) => (
  <li css={rowStyle}>
    <OfficialAvatar official={official} size={32} />
    <span css={nameStyle}>
      <Text variant='paragraphSmall' weight='medium' color={colors.WHITE}>
        {official.fullName}
      </Text>
      {official.roleName ? (
        <Text
          variant='paragraphXSmall'
          weight='regular'
          color={colors.NEUTRAL_50}
        >
          {official.roleName}
        </Text>
      ) : null}
    </span>
    {official.isTreasurer ? (
      <span css={pillStyle}>
        <DollarOutlined aria-hidden='true' />
        <Text
          variant='paragraphXSmall'
          weight='medium'
          color={colors.SUCCESS_100}
        >
          {capitalizeWords(treasurerLabel)}
        </Text>
      </span>
    ) : null}
  </li>
)

export default SummaryOfficialRow

const rowStyle = css`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`

const nameStyle = css`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
`

/* The green is the success tint at 16% behind its lighter text tone. */
const pillStyle = css`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 8px;
  background-color: ${colors.SUCCESS_200}29;
  color: ${colors.SUCCESS_100};
`
